'use client';

import { useEffect } from 'react';
import { useTenantAndVariant } from '@multitenancy/TenantAndVariantContext';
import { HeroClassic } from './HeroClassic';
import { HeroShowcase } from './HeroShowcase';
import { HeroMinimal } from './HeroMinimal';

const Hero = () => {
  const { heroVariant, setHeroVariant, featureToggles } = useTenantAndVariant();

  // Auto-rotate hero every 10 seconds
  useEffect(() => {
    if (!featureToggles.autoRotateHero) return;

    const interval = setInterval(() => {
      if (heroVariant === 'classic') {
        setHeroVariant('showcase');
      } else if (heroVariant === 'showcase') {
        setHeroVariant('minimal');
      } else {
        setHeroVariant('classic');
      }
    }, 10000); // 10 seconds

    return () => clearInterval(interval);
  }, [featureToggles.autoRotateHero, heroVariant, setHeroVariant]);

  return (
    <>
      {heroVariant === 'classic' && <HeroClassic />}
      {heroVariant === 'showcase' && <HeroShowcase />}
      {heroVariant === 'minimal' && <HeroMinimal />}
    </>
  );
};

export default Hero;
